class DynamicListLoader extends HTMLElement {
  selectors = {
    item: "[data-item]"
  };

  attributes = {
    id: "id",
    itemsCount: "items-count",
    itemsToShow: "items-to-show",
    itemsToLoad: "items-to-load"
  };

  modifiers = {
    hidden: "hidden"
  };

  get id() {
    return this.getAttribute(this.attributes.id);
  }

  get itemsCount() {
    return parseInt(this.getAttribute(this.attributes.itemsCount));
  }

  get itemsToShow() {
    return parseInt(this.getAttribute(this.attributes.itemsToShow));
  }

  get itemsToLoad() {
    return parseInt(this.getAttribute(this.attributes.itemsToLoad));
  }

  constructor() {
    super();

    this.itemElements = [...this.querySelectorAll(this.selectors.item)];
    this.loadMoreButtonElement = document.querySelector(`[aria-controls="${this.id}"]`);

    this.itemsRemaining = this.itemsCount - this.itemsToShow;

    console.log("this.itemsRemaining", this.itemsRemaining);

    this.onLoadMoreButtonClicked = this.onLoadMoreButtonClick.bind(this);
  }

  connectedCallback() {
    if (this.id) {
      document.addEventListener("click", this.onLoadMoreButtonClicked);
    }
  }

  disconnectedCallback() {
    if (this.id) {
      document.removeEventListener("click", this.onLoadMoreButtonClicked);
    }
  }

  onLoadMoreButtonClick(event) {
    const button = event.target.closest(`[aria-controls="${this.id}"]`);

    if (!button) {
      return;
    }

    this.loadMoreItems();
  }

  loadMoreItems() {
    const startIndex = this.itemsCount - this.itemsRemaining;
    const endIndex = startIndex + this.itemsToLoad;

    const itemsToShow = this.itemElements.slice(startIndex, endIndex);

    itemsToShow.forEach((item) => {
      item.classList.remove(this.modifiers.hidden);
    });

    this.itemsRemaining = Math.max(this.itemsRemaining - this.itemsToLoad, 0);

    this.loadMoreButtonElement.classList.toggle(
      this.modifiers.hidden,
      !(this.itemsRemaining > 0)
    );
  }
}

if (!customElements.get("dynamic-list-loader")) {
  customElements.define("dynamic-list-loader", DynamicListLoader);
}
